import gql from "graphql-tag";
const getEntityDB_CompanyDetails = gql(`
query MyQuery {
  EntityDB_CompanyDetails {
    CACanDate
    CALPNum
    CARegDate
    CAStatus
    Country
    Custodian
    DealRef
    DissolveDate
    EIN
    EntityStatus
    EntityType
    FYEnd
    ForeignCounsel
    FundAuditor
    FundFamily
    GP
    LoC
    LocAmount
    MainAddress
    PlaceAgent
    PrimeBroker
    Purpose
    QuickRef
    RegAddress
    RegAgent
    RegDate
    RegNum
    SAClient
    State
    TaxProvider
    USCounsel
    WCLicenseNum
    CompanyName 
    }
  }
`);
export default getEntityDB_CompanyDetails;
